import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Loader } from "@progress/kendo-react-indicators";
import { Input } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import CenterDivPanel from '../../components/CenterDivPanel';
import { EditableAddress } from '../../components/EditableAddress';
import { CreatingField } from '../../components/CreatingField';
import { fetchApi } from '../../services/api';
import { AddressViewModel } from '../../TypeGen/Driver/Profile/address-view-model';
import { isNullOrWhiteSpace } from '../../utils/utils';
import { JsonResponse } from 'TypeGen/json-response';

type Props = {
    CloseDialog: () => void;
}

const AddCarrierDialog = (props: Props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [carrierName, setCarrierName] = useState('');
    const [address, setAddress] = useState<AddressViewModel>({ AddressLine1: '', AddressLine2: '', City: '', State: '', ZipCode: '', Coordinates: { Latitude: 0, Longitude: 0 } });
    const [mcNumber1, setMcNumber1] = useState('');
    const [dotNumber, setDotNumber] = useState('');
    const [primaryPhoneNumber, setPrimaryPhoneNumber] = useState('');

    const history = useHistory();

    const hasAddress = address.AddressLine1.length > 0 && ((address.City.length > 0 && address.State.length > 0) || address.ZipCode.length > 0);
    const canSave = (hasAddress && isNullOrWhiteSpace(carrierName) === false);

    const _save = () => {
        if (canSave === false)
            return;

        setLoading(true);

        const data = {
            CarrierName: carrierName,
            Address: address,
            PrimaryPhoneNumber: primaryPhoneNumber,
            MCNumber1: mcNumber1,
            USDOT: dotNumber
        }

        fetchApi('/api/Asset/AddCarrier', data, 'POST')
            .then((response: JsonResponse) => {
                setLoading(false);
                if (response.Success) {
                    const link = response.Links.find(l => l.Name === 'CarrierProfile');
                    if (link) history.push(link.Link);
                    props.CloseDialog();
                } else {
                    alert(response.ErrorMessage);
                }
            }
            ).catch((e) => {
                setLoading(false);
                // If not problem details
                if (!e?.status) alert(e);
            });
    }

    return <div className="container-fluid">
        <Dialog title={'Create Carrier Profile'} onClose={props.CloseDialog} width={400} height={625}>
            {loading && <CenterDivPanel>
                <Loader type="converging-spinner" />
            </CenterDivPanel>}
            <div className="k-form k-form-md p-0">
                <div>
                    <FieldWrapper>
                        {/*<Label>Carrier Name</Label>*/}
                        <Input
                            required
                            maxLength={40}
                            autoFocus
                            disabled={loading}
                            value={carrierName}
                            label="Carrier Name"
                            onChange={(e) => setCarrierName(e.value || '')}
                        />
                    </FieldWrapper>
                    <FieldWrapper>
                        <Label>Carrier Address</Label>
                        <EditableAddress
                            data={address}
                            title="Carrier Address"
                            save={async (e) => setAddress(e)}
                        />
                    </FieldWrapper>
                    <FieldWrapper>
                        <Label>MC Number</Label>
                        <CreatingField
                            dataType='string'
                            inputProps={{ maxLength: 15 }}
                            data={mcNumber1}
                            onChange={(e) => setMcNumber1(e)}
                        />
                    </FieldWrapper>
                    <FieldWrapper>
                        <Label>U.S. DOT Number</Label>
                        <CreatingField
                            dataType='string'
                            inputProps={{ maxLength: 10 }}
                            data={dotNumber}
                            onChange={(e) => setDotNumber(e)}
                        />
                    </FieldWrapper>
                    <FieldWrapper>
                        <Label>Phone Number (optional)</Label>
                        <CreatingField
                            dataType='intlphone'
                            data={primaryPhoneNumber}
                            onChange={(e) => setPrimaryPhoneNumber(e)}
                        />
                    </FieldWrapper>
                </div>
            </div>

            <DialogActionsBar>
                <Button onClick={props.CloseDialog}>Cancel</Button>
                <Button themeColor="primary" disabled={canSave === false || loading} onClick={_save}>
                    Create Carrier
                </Button>
            </DialogActionsBar>
        </Dialog>
    </div>
}

export default AddCarrierDialog;

